import { render, staticRenderFns } from "./CompBgImageButton.vue?vue&type=template&id=3f785b9c"
import script from "./CompBgImageButton.vue?vue&type=script&lang=js"
export * from "./CompBgImageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports